import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      uid: '',
      type: '',
      subType: "",
      data: {}
    },
    promotionCodes: [] as any[],
  },
  mutations: {},
  actions: {},
  modules: {}
})
